import type { Location } from 'modules/core/lib/navigation/types'

export const upgradeLegacyNavigation = {
  path: 'update_plan',
} as const satisfies Location
